import {Typography, Box, Button} from '@mui/material';
import {useWrappedTheme} from '@jobseeker/lotus/hooks';
import {Image} from '@jobseeker/lotus/components/Image';
import {TalentBridgeJob} from './TalentBridgeJob';
import {useEffect} from 'react';
import {fetchRecuiterJobFeed} from '@jobseeker/common-core/reducers/job/thunkServices/jobfeed';
import {useDispatch, useSelector} from 'react-redux';
import {openUrl} from '@jobseeker/common-core/utils';
import Loader from '@jobseeker/lotus/components/Loader';

import type {Job, AppState} from '@jobseeker/common-core/types';
import React from 'react';
import {DriveBanner, TALENT_BRIDGE_REC_ID} from '../utils';

type TalentBridgeListingProps = {
  driveBannerObj: DriveBanner;
};

export const TalentBridgeListing = ({
  driveBannerObj,
}: TalentBridgeListingProps) => {
  const theme = useWrappedTheme();
  const authStore = useSelector((state: AppState) => state.auth);

  const jobFeedStore = useSelector((state: AppState) => state.job);
  const isLoading = jobFeedStore?.isLoading;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const dispatch = useDispatch<any>();

  const {userId} = authStore || {};

  useEffect(() => {
    dispatch(
      fetchRecuiterJobFeed({
        userId: userId,
        recruiterId: driveBannerObj?.recruiterId || TALENT_BRIDGE_REC_ID,
        showAllJobs: true,
      })
    );
  }, []);

  const ExploreJobFeedDiv = ({children}: {children: React.ReactNode}) => (
    <Box
      sx={{
        mt: 6.625,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      {children}
    </Box>
  );

  return (
    <Box
      sx={{
        bgcolor: '#f2f5fa',
        pt: 5,
        height: '500px',
        pl: {xxs: 3.75, sm: 12.5},
      }}
    >
      <Box
        sx={{
          verticalAlign: 'top',
          mr: {xxs: 0, md: 37.5},
          maxWidth: '100%',
          ml: -1.875,
        }}
      >
        <Typography
          sx={{
            fontSize: {
              xxs: theme.typography.pxToRem(18),
              md: theme.typography.pxToRem(20),
            },
            fontWeight: 'bold',
            m: '0 0 15px 0',
          }}
        >
          Job Opportunities at Talent Bridge
        </Typography>
        {!jobFeedStore?.jobfeed || isLoading === null ? (
          <Box
            sx={{
              display: 'flex',
              textAlign: 'center',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Loader />
          </Box>
        ) : jobFeedStore?.jobfeed && jobFeedStore?.jobfeed?.length > 0 ? (
          jobFeedStore?.jobfeed?.map((job, index) => (
            <TalentBridgeJob key={job.id} job={job as Job} jobPos={index + 1} />
          ))
        ) : null}

        <ExploreJobFeedDiv>
          <Typography
            sx={{
              fontSize: theme.typography.pxToRem(17),
              fontWeight: 600,
              color: '#212529',
              lineHeight: '1.2',
            }}
          >
            Didn&apos;t find a relevant job at our hiring drive?
          </Typography>
          <Box
            sx={{
              marginTop: '4px',
              marginBottom: '26px',
            }}
          >
            <Image
              src={
                'https://job-static.hirist.com/V8/static/media/no-jobfeed.7771e408.svg'
              }
              alt="no jobfeed"
              width={460}
              height={357}
              style={{
                width: '100%',
                height: '100%',
              }}
            ></Image>
          </Box>
          <Button
            variant="outlined"
            sx={{
              mb: 10.125,
              height: '48px',
              p: '13px 20px 13px 20px',
              borderRadius: 2.5,
              border: '1px solid primary.main',
              bgcolor: '#f3f5f9',
              '&:hover': {
                bgcolor: 'primary.main',
                color: '#fff',
              },
              '&:focus': {
                outline: 'unset',
              },
              fontSize: theme.typography.pxToRem(16),
              fontWeight: 'bold',
              lineHeight: 'normal',
              color: 'primary.main',
            }}
            onClick={() => openUrl('/jobfeed', '_blank')}
          >
            Explore our job feed
          </Button>
        </ExploreJobFeedDiv>
      </Box>
    </Box>
  );
};

export default TalentBridgeListing;
